import Navbar from '../../components/layout/Navbar';
import Dashboard from '../../components/sections/Dashboard';
import Footer from '../../components/layout/Footer';

export default function DashboardPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar activeSection="dashboard" />

      <main className="pt-16">
        <Dashboard />
      </main>

      <Footer />
    </div>
  );
}